import { useMutation, useQueryClient } from '@tanstack/react-query';

import BackendService from '../services/backendService';
import { ReportInsightType } from './useReportInsights';
import useRouterMatch from './useRouterMatch';

const useDeleteReportInsight = () => {
  const queryClient = useQueryClient();
  const { gameId: livePresentationId } = useRouterMatch();
  const { mutate: deleteReportInsight, isPending: isLoading } = useMutation({
    mutationFn: async ({ reportType }: { reportType: ReportInsightType }) => {
      return BackendService.instance.ai.deleteReportInsight({
        reportType,
        livePresentationId,
      });
    },

    onMutate: async ({ reportType }) => {
      queryClient.setQueryData(
        ['report-insight', reportType, livePresentationId, ''],
        null,
      );
    }
  });

  return {
    deleteReportInsight,
    isLoading,
  };
};

export default useDeleteReportInsight;
